module.exports = __webpack_public_path__ + "img/lawless-zone.81d58730.jpg";